import { createFileRoute, useParams } from '@tanstack/react-router';
import { DictionariesPage } from '@/modules/dictionaries/dictionaries-page';

interface DictionariesSearch {
  /** Encoded filter selection, shared by every page that has filters. */
  f?: string;
}

/**
 * One route for every reference-data page: the slug is the legacy GroupName and
 * the server answers with the tabs, columns and form of that page.
 */
export const Route = createFileRoute('/_auth/dictionaries/$kind')({
  validateSearch: (search: Record<string, unknown>): DictionariesSearch => ({
    f: typeof search.f === 'string' ? search.f : undefined,
  }),
  component: DictionariesRoute,
});

function DictionariesRoute() {
  const { kind } = useParams({ from: '/_auth/dictionaries/$kind' });
  return <DictionariesPage kind={kind} />;
}
